// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconClose: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd"><rect width="20" height="20" fill="currentColor" rx="2"/><rect width="20" height="20" fill="currentColor" opacity=".8" rx="2"/><path fill="#FFF" fill-rule="nonzero" d="M7.15709734,14.7383468 L10,11.8954441 L12.8429027,14.7383468 C13.1917458,15.0872177 13.7576519,15.0872177 14.1065228,14.7383468 L14.7383468,14.1065228 C15.0872177,13.7576519 15.0872177,13.192051 14.7383468,12.8429027 L11.8954441,10 L14.7383468,7.15709734 C15.0872177,6.80825416 15.0872177,6.24262551 14.7383468,5.89347715 L14.1065228,5.26165319 C13.7576519,4.91278227 13.192051,4.91278227 12.8429027,5.26165319 L10,8.10455585 L7.15709734,5.26165319 C6.80825416,4.91278227 6.24262551,4.91278227 5.89347715,5.26165319 L5.26165319,5.89347715 C4.91278227,6.24234807 4.91278227,6.80794899 5.26165319,7.15709734 L8.10455585,10 L5.26165319,12.8429027 C4.91278227,13.1917458 4.91278227,13.7573745 5.26165319,14.1065228 L5.89347715,14.7383468 C6.24234807,15.0872177 6.80825416,15.0872177 7.15709734,14.7383468 Z"/></g></svg>
    );
};

export default React.memo(IconClose);
